export enum DatasourceTypeEnum {
    SharePointDocumentTemplate = 0,
    SQLServer = 1,
    UniveCRM = 2,
    SimplicateOrganization = 3,
    SimplicateProject = 4,
    SimplicateEmployee = 5,
    SharePoint = 6,
    Internal = 7,
    Exchange = 8
}